import Cookies from "js-cookie";
const psl = require("psl");

export function setCookieItem (key, value, options = {}) {
    if (process.client) {
      console.log(process.client);
      const pPsl = psl.parse(document.domain);
      let domain = pPsl.domain;
      if (/\d+\.\d+\.\d+\.\d+/.test(pPsl.input)) domain = pPsl.input;
      options = { domain, ...options };
    }
    Cookies.set(key, value, options);
    //用户信息特殊处理，处理过期时间
    if(key == 'userInfo'){
      Cookies.set("userInfoExpiry", Date.now()+60*1000);
    }
  }
export function getCookieItem(key) {
    return Cookies.get(key);
  }
export function removeCookieItem(key, options = {}) {
    if (process.client) {
      const pPsl = psl.parse(document.domain);
      let domain = pPsl.domain;
      if (/\d+\.\d+\.\d+\.\d+/.test(pPsl.input)) domain = pPsl.input;
      options = { domain, ...options };
    }
    Cookies.remove(key, options);
  }
  // 获取是否登录
export function   getHasLogin() {
    return this.getItem("userInfo") != null ? true:false;
  }
